import HowToInstall from "@/shared-steps/HowToInstall";
import DeviceSelect from "@/shared-steps/DeviceSelect";
import AddCamera from "./AddCamera";
import InstallOnOtherDevice from "./InstallOnOtherDevice";
import EnterCode from "./EnterCode";
import Waiting from "./Waiting";
import CantFindCode from "./CantFindCode";
import HowTo from "./HowTo";
import CameraName from "./CameraName";
import CameraCustomization from "./CameraCustomization";
import CameraUsage from "./CameraUsage";
import Customizing from "./Customizing";
import ScanCode from "./ScanCode";

const steps = [
  { id: "add-camera", Component: AddCamera },
  { id: "install-on-other-device", Component: InstallOnOtherDevice },
  { id: "how-to", Component: HowTo },
  { id: "scan-code", Component: ScanCode },
  { id: "enter-code", Component: EnterCode },
  { id: "waiting", Component: Waiting },
  { id: "camera-name", Component: CameraName },
  { id: "camera-customization", Component: CameraCustomization },
  { id: "camera-usage", Component: CameraUsage },
  { id: "customizing", Component: Customizing },
  { id: "cant-find-code", Component: CantFindCode },
  { id: "how-to-install", Component: HowToInstall },
  { id: "device-select", Component: DeviceSelect }
] as {
  id: string;
  Component: (props: FlowProviding & Keyable) => React.ReactNode;
}[];

export default steps;
